import { useResetTimestampWhenAllTimesAreZeroEffect } from './use-reset-timestamps-when-all-times-are-zero-effect';
import { useBetweenBlocksIntervalEffect } from './use-between-blocks-interval-effect';
import { useLastSMSIntervalEffect } from './use-last-sms-interval-effect';

export const useMobileVerificationIntervals = () => {
  useLastSMSIntervalEffect();
  useBetweenBlocksIntervalEffect();
  useResetTimestampWhenAllTimesAreZeroEffect();
};
